fragment SearchTagFragment on Tag {
  deleted
  id
  name
  description
  aliases
}

query SearchTags($term: String!, $limit: Int = 5) {
  exact: findTagOrAlias(name: $term) {
    ...SearchTagFragment
  }
  query: searchTag(term: $term, limit: $limit) {
    ...SearchTagFragment
  }
}
